import { type itemDefinition, Items } from './item.type';

import { consumables } from './items/consumables';
import { dies } from './items/dies';
import { specials } from './items/specials';
import { potions } from './items/potions';

export const createItem = (type: Items) => {
  const itemDefinition = items.find((item) => item.type == type);
  if (!itemDefinition) {
    throw new Error(`Item ${type} not found`);
  }
  const item = new itemDefinition.class(itemDefinition);
  return item;
};

export const items: Array<itemDefinition> = [...consumables, ...dies, ...specials, ...potions];
